import React from "react";
import ThemeFocus from "../../focus/focus_theme";
import { useTranslation } from "react-i18next";

function filterThemeTree(included_themes, all_themes) {
  let ids = {};
  included_themes.forEach((x) => {
    ids[x.root] = true;
    ids[x.subroot] = true;
    ids[x.id] = true;
  });

  return all_themes
    .filter((root) => {
      return ids[root.id];
    })
    .map((root) => {
      const subroots = root.children
        .filter((subroot) => ids[subroot.id])
        .map((subroot) => {
          const leaves = subroot.children.filter((leaf) => ids[leaf.id]);

          return { ...subroot, children: leaves };
        });
      return { ...root, children: subroots };
    });
}

function Themes({ dataList, route }) {
  const { t } = useTranslation();

  const mode = { editable: false, display: "all" };
  const [search, setSearch] = React.useState("");

  let view;
  let focus = [];
  let filtered_theme_tree = [];
  let data = [];

  if (route === "contact") {
    focus = [];
    dataList.contact.themes.map((c) => focus.push(c.id));
    filtered_theme_tree = filterThemeTree(
      dataList.contact.themes,
      dataList.themes,
    );
  } else if (route === "entity") {
    focus = [];
    dataList.entity.themes.map((c) => focus.push(c.id));
    filtered_theme_tree = filterThemeTree(
      dataList.entity.themes,
      dataList.themes,
    );
  } else {
    focus = [];
    focus.push(dataList.theme.id);
    data.push(dataList.theme);
    filtered_theme_tree = filterThemeTree(data, dataList.themes);
  }

  if (filtered_theme_tree.length === 0) {
    view = <p>{t("Aucun élément à afficher")}</p>;
  } else {
    // filter themes tree, only keeping entity's themes

    view = (
      <ThemeFocus
        themes={filtered_theme_tree}
        focus={focus}
        notify={() => {}}
        mode={mode}
        search={search}
        setSearch={setSearch}
      />
    );
  }
  return <>{view}</>;
}

export default Themes;
